export const CONFIRMATION_CODE_TIMER_SECONDS = 120;
export const MAX_PAGE_LIMIT = 10;
export const MAX_PAGE_LIMIT_MOBILE = 2;

export const MAX_ADS_PAGE_LIMIT = 3;

export const MAX_PACKAGES_PAGE_LIMIT = 12;

export const MEMBER_SLIDER_MAX = 50_000_000;
export const MEMBER_SLIDER_MIN = 10_000;
export const MEMBER_SLIDER_STEP = 10_000_000;

export const PRICE_SLIDER_MAX = 50_000_000;
export const PRICE_SLIDER_MIN = 200_000;
export const PRICE_SLIDER_STEP = 10_000_000;

export const VIEW_SLIDER_MAX = 500_000;
export const VIEW_SLIDER_DEFAULT = 100_000;

export const BUDGET_INPUT_DEFAULT_VALUE = 100_0000;

export const MAX_FILE_SIZE_MB = 300;
export const BYTES_IN_MB = 1024 * 1024;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * BYTES_IN_MB;

export const PAGE_SIZE = 10;
export const CONFIRM_CODE_BOXES = 5;
export const MIN_PASSWORD_INPUT_LENGTH = 6;

export const DELAY_BEFORE_SEARCH = 500;
